
import PlatformSettings from "@/components/admin/PlatformSettings";
import PaymentSettings from "@/components/admin/PaymentSettings";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Settings } from "lucide-react";

const SettingsAndConfigurations = () => {
  return (
    <div className="space-y-8">
        <Card className="bg-transparent border-0 shadow-none">
            <CardHeader className="p-0 mb-6">
                <CardTitle className="text-white flex items-center text-2xl">
                    <Settings className="w-6 h-6 mr-3" />
                    Settings & Configurations
                </CardTitle>
                <p className="text-gray-400">Manage platform-wide rules, policies, and system settings.</p>
            </CardHeader>
            <CardContent className="p-0 space-y-8">
              <PlatformSettings />
              <PaymentSettings />
            </CardContent>
        </Card>
    </div>
  );
};

export default SettingsAndConfigurations;
